/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_id: z.string().uuid(),
  sort_order: z.number(),
  process_execution_id: z.string().uuid().nullable(),
  work_detail_id: z.number().nullable(),
  mix_ratio_definition_id: z.number().nullable(),
  started_at: z.number().nullable(),
  finished_at: z.number().nullable(),
  duration_seconds: z.number().nullable(),
  remarks: z.string().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  sort_order: base.shape.sort_order.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const StirBatchBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type StirBatchBase = z.infer<typeof base>;
export type StirBatchBasePutPayload = z.infer<typeof put>;
export type StirBatchBasePatchPayload = z.infer<typeof patch>;
export type StirBatchBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type StirBatchBaseCreateAttributes = z.infer<typeof create>;
export type StirBatchBaseUpdateAttributes = z.infer<typeof update>;
export type StirBatchBaseCacheAttributes = z.infer<typeof cache>;
export type StirBatchBaseCachesAttributes = z.infer<typeof caches>;